/**
 * @file UploadFromDeviceModal.js
 * @description Modal wrapper for uploading a file from the user's device.
 * Reuses the shared AssetForm component in ADD mode.
 */

import PropTypes from 'prop-types';
import style from './modals.module.scss';
import AssetForm, { ASSET_FORM_MODE } from '../../plans/tabs/AssetForm';
import { getText } from '../../../i18n';

const UploadFromDeviceModal = ({ title, subtitle, onYes, onNo, onHide }) => {
    const handleSaved = savedAsset => {
        onYes({
            url: savedAsset.url,
            id: savedAsset.id,
        });
        onHide();
    };

    const handleCancel = () => {
        onNo();
        onHide();
    };

    return (
        <div className={`${style.container} modal-backdrop`}>
            <div
                className="modal fade show d-block"
                tabIndex="-1"
                aria-modal="true"
                role="dialog"
            >
                <div
                    className={`modal-dialog modal-lg modal-dialog-centered ${style.modalSizing}`}
                >
                    <div className={`modal-header ${style.modalHeader}`}></div>
                    <div className={`modal-content ${style.modalContent}`}>
                        <button
                            type="button"
                            className={`ing-text-buttons-save absolute-position pointer-cursor ${style.closeAction}`}
                            onClick={handleCancel}
                            aria-label={getText('msg_bbfa773e5a63')}
                        >
                            <i className={`bi bi-x ${style.closeActionIcon}`} />
                            {getText('msg_bbfa773e5a63')}
                        </button>
                        <div
                            className={`modal-body ${style.modalBody} ${style.modalBodyTopAligned}`}
                        >
                            <AssetForm
                                mode={ASSET_FORM_MODE.ADD}
                                entityLabel={getText('msg_05fac94380a7')}
                                title={title}
                                subtitle={subtitle}
                                onSaved={handleSaved}
                                onCancel={handleCancel}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

UploadFromDeviceModal.propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    onYes: PropTypes.func.isRequired,
    onNo: PropTypes.func,
    onHide: PropTypes.func.isRequired,
};

export default UploadFromDeviceModal;
